// SoHT Site JavaScript
import Utility from "../../ts/classes/utility";
import { sohtGSAP } from "./gsap";
import "./gsap"; // Import for accordion functionality
import "./hospitality-group";

declare global {
    interface Window {
        sohtSite: any;
    }
}

class SoHTSite {
    constructor() {
        this.init();
    }

    private init(): void {
        console.log('SoHT Site initialized');
        
        // Initialize GSAP animations
        sohtGSAP.init();
        
        // Add any additional SoHT-specific JavaScript functionality here
        this.setupEventListeners();
    }

    private setupEventListeners(): void {
        // Add any custom event listeners for SOHT site
        console.log('SOHT event listeners setup complete');
        
        // Note: Hero media toggle functionality is handled in the HTML file
        // to ensure proper integration with the video element
    }
}

// Initialize SoHT site
const globalInit = function () {
    window.sohtSite = new SoHTSite();
}

// Fix for cookie consent if needed
Utility.cookieYesFix();
globalInit();
